/*
 * GO Trade click tracking. Publishes a `go_trade_click` custom event on Shopify's Customer Events
 * bus for every click on a link to the Trade store (dulora.pro, account.dulora.pro, www.dulora.pro).
 *
 * GA4 runs inside Shopify web-pixel sandboxes (Simprosys), which cannot see clicks on the page, so
 * enhanced-measurement outbound clicks never fire. A Customer Events custom pixel subscribes to this
 * event and forwards it to GA4 — see docs/superpowers/2026-10-06-ga4-tracking-audit.md.
 *
 * Placement comes from the link's data-go-trade attribute, else the nearest header/footer landmark.
 * Param names link_url / link_domain / link_text match GA4's built-in outbound-click dimensions.
 *
 * Every Trade link also gets UTMs (source = this retail domain, medium = referral, campaign = go_trade,
 * content = placement) so dulora.pro's own Shopify reports attribute signups and orders to the retail
 * site. link_url is reported without them so GA4 keeps one row per destination. Existing utm_* on a
 * link (set by hand in the theme editor) are left alone.
 */
(function () {
  if (window.__duloraGoTradeInit) return; window.__duloraGoTradeInit = true;

  var TRADE_HOST = /(^|\.)dulora\.pro$/i;

  function placementFor(link) {
    if (link.dataset.goTrade) return link.dataset.goTrade;
    if (link.closest('footer')) return 'footer';
    if (link.closest('header, .announcement')) return 'header';
    return 'other';
  }

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

  function addUtms(link) {
    if (!TRADE_HOST.test(link.hostname)) return;
    try {
      var url = new URL(link.href);
      if (url.searchParams.has('utm_source')) return;
      url.searchParams.set('utm_source', location.hostname.replace(/^www\./, ''));
      url.searchParams.set('utm_medium', 'referral');
      url.searchParams.set('utm_campaign', 'go_trade');
      url.searchParams.set('utm_content', placementFor(link));
      link.href = url.toString();
    } catch (e) { /* malformed href: leave it as authored */ }
  }

  function cleanUrl(link) {
    try {
      var url = new URL(link.href);
      UTM_KEYS.forEach(function (k) { url.searchParams.delete(k); });
      return url.toString();
    } catch (e) { return link.href; }
  }

  function track(evt) {
    // Middle-click opens the Trade store in a new tab: still a GO Trade click
    if (evt.type === 'auxclick' && evt.button !== 1) return;
    var link = evt.target.closest && evt.target.closest('a[href]');
    if (!link || !TRADE_HOST.test(link.hostname)) return;
    // Links injected after load (mobile nav clones) are decorated here, before the browser navigates
    addUtms(link);
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    try {
      analytics.publish('go_trade_click', {
        placement: placementFor(link),
        link_url: cleanUrl(link),
        link_domain: link.hostname,
        link_text: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100)
      });
    } catch (e) { /* tracking must never block navigation */ }
  }

  function decorateAll() {
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="dulora.pro"]'), addUtms);
  }
  // Decorate up front so hover, copy-link and right-click → open show the tagged URL too
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateAll);
  else decorateAll();

  // Capture phase so handlers that stop propagation (menus, drawers) can't swallow the click
  document.addEventListener('click', track, true);
  document.addEventListener('auxclick', track, true);
})();
